import Layout from './Layout'
import styles from './Controls.module.css'

export default function InputGroup({ type, name, label, description, options, register }) {
    if (options instanceof Map) {
        options = Object.fromEntries(options)
    }

    options = Object.entries(options)

    const className = options.length > 5 ? styles.InputGroupAutoColumn : null

    return (
        <Layout name={name} description={description}>
            <label>{label}</label>
            <div className={className}>
                {options.map(([value, display]) => (
                    <label key={value}>
                        <input type={type} defaultValue={value} name={name} ref={register} />
                        {display}
                    </label>
                ))}
            </div>
        </Layout>
    )
}
